export const dropdownListClasses = {
  selectedItem: 'dropdown-list-item-selected',
}
